var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 31,
    viewBox: "0 0 39 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 0.5H4.5C2.4375 0.5 0.75 2.1875 0.75 4.25V26.75C0.75 28.8125 2.4375 30.5 4.5 30.5H34.5C36.5625 30.5 38.25 28.8125 38.25 26.75V4.25C38.25 2.1875 36.5625 0.5 34.5 0.5ZM33.75 8.46875L21.4875 16.1375C20.2688 16.9062 18.7312 16.9062 17.5125 16.1375L5.25 8.46875C5.06199 8.36321 4.89735 8.22061 4.76604 8.0496C4.63473 7.87859 4.53949 7.68271 4.48608 7.47382C4.43267 7.26493 4.42219 7.04738 4.45529 6.83433C4.48839 6.62127 4.56438 6.41715 4.67865 6.23431C4.79293 6.05148 4.94311 5.89373 5.12011 5.77062C5.29712 5.6475 5.49726 5.56158 5.70843 5.51806C5.9196 5.47454 6.13741 5.47431 6.34867 5.5174C6.55992 5.56049 6.76024 5.646 6.9375 5.76875L19.5 13.625L32.0625 5.76875C32.2398 5.646 32.4401 5.56049 32.6513 5.5174C32.8626 5.47431 33.0804 5.47454 33.2916 5.51806C33.5027 5.56158 33.7029 5.6475 33.8799 5.77062C34.0569 5.89373 34.2071 6.05148 34.3213 6.23431C34.4356 6.41715 34.5116 6.62127 34.5447 6.83433C34.5778 7.04738 34.5673 7.26493 34.5139 7.47382C34.4605 7.68271 34.3653 7.87859 34.234 8.0496C34.1027 8.22061 33.938 8.36321 33.75 8.46875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.a4ebcd5238fd0cda39ce418a26e3d41e.svg";
export { ForwardRef as ReactComponent };